<template>
  <div class="custom">
    <!-- <div class="header">休假申请</div> -->
    <!-- <p class="title">休假申请基础信息新增</p> -->
    <van-nav-bar
        title="休假申请基础信息新增"
        left-text="返回"
        left-arrow
        placeholder
        fixed
        @click-left="onClickLeft"
    />
    <van-form @submit="onSubmit">
        <van-field
            v-model="form.username"
            name="用户名"
            label="用户名"
            label-width="7.2em"
            readonly
            placeholder="请输入客户名称"
        />
        <van-field-select-picker
            v-model="form.categoryStr"
            type="select"
            :columns="levelOne"
            :option="{label:'name',text:'name',value:'seqId'}"
            @confirm="onOrderClassify"
            name="休假类别（I）"
            label="休假类别（I）"
            label-width="7.2em"
            placeholder="请选择休假类别（I）"
            :disabled="disabledOne"
        />
        <van-field-select-picker
            v-model="form.classifyStr"
            type="select"
            :columns="levelTwo"
            :option="{label:'name',text:'name',value:'seqId'}"
            @confirm="onOrderChildClassify"
            name="休假类别（II）"
            label="休假类别（II）"
            label-width="7.2em"
            placeholder="请选择休假类别（II）"
        />
        <van-field
            readonly
            clickable
            name="calendar"
            :value="startTimeStr"
            label="开始时间"
            label-width="7.2em"
            placeholder="选择开始休假时间"
            @click="startshow(1)"
            @focus="a"
            />
        <van-calendar v-model="show" @confirm="onConfirm" color="#1989fa"/>
        <van-field
            readonly
            clickable
            name="calendar"
            :value="endTimeStr"
            label="结束时间"
            label-width="7.2em"
            placeholder="选择结束休假时间"
            @click="startshow(2)"
            @focus="a"
            />
        <van-calendar v-model="show" @confirm="onConfirm" color="#1989fa"/>
        <van-field
            v-model="form.reason"
            rows="2"
            autosize
            label="休假原因"
            label-width="7.2em"
            type="textarea"
            maxlength="50"
            placeholder="请输入休假原因"
            show-word-limit
        />
        <div style="margin: 16px;">
            <van-button round block type="info" native-type="submit">提交</van-button>
        </div>
    </van-form>

    <div style="margin-bottom: 40px"></div>


    <base-dialog v-if="messageVisible" :title="title" width="80%" @close="close">
        <p>{{ message }}</p>
    </base-dialog>
</div>
</template>
<script>
import {add,get} from '@/api/UserApply'
import {account} from '@/api/Login'
import {getLevelOne,getLevelTwo,getLevelId} from '@/api/Classify'
import BaseDialog from "@/components/BaseDialog";
import { Calendar } from 'vant'
import { Cell } from "vant";
import { Form } from 'vant';
import { Field } from 'vant';
import VanFieldSelectPicker from "@/components/VanFieldSelectPicker";
import { DropdownMenu, DropdownItem } from 'vant';
import { NavBar } from 'vant';
import { Popup } from 'vant'
import { Picker } from 'vant';
import { Dialog } from 'vant';
import Vue from 'vue';
Vue.use(Calendar)
Vue.use(Form);
Vue.use(Field);
Vue.use(Cell);
Vue.use(DropdownMenu); 
Vue.use(DropdownItem);
Vue.use(Popup);
Vue.use(Picker);
Vue.use(NavBar);

export default {
  name: "addUserApply",
  components: {BaseDialog, VanFieldSelectPicker},
        data() {
            return {
                seqId: this.$route.query.sId,
                levelOneId: this.$route.query.levelOneId,
                levelTwoId: this.$route.query.levelTwoId,
                form: {
                    username: '',
                    category: '',
                    reason: '个人原因',
                    classify: '',
                    categoryStr: '',
                    classifyStr: '',
                    startTime: '',
                    endTime: ''
                },
                levelOne: [],
                levelTwo: [],
                disabledOne: false,
                categoryShow: false,
                classifyShow: false,
                keyValue: '',
                classifyInput:true,
                membersList: [],
                defaultMemberId: '', //默认选中第一个
                username: '',
                mobile: '',
                address: '',
                memberNo: '',

                title: '提示',
                messageVisible: false,
                message: "",
                btnDisable: false,
                isSuccess: false,
                date: '',
                startTimeStr: '',
                endTimeStr: '',
                timeType: '',
                show: false
            }
        },
        created() {
            if(this.$route.query.sId == undefined){
                this.getUserApplyOne();
            }else{
                this.getUserApplyTwo();
            }
            if(this.levelOneId != undefined){
                this.getLevelOneName();
                this.disabledOne = true;
            }
        },
        methods: {
            getUserApplyTwo(){
                get(this.seqId)
                    .then((response) => {
                        this.form.username = response.data.username;
                        getLevelOne()
                            .then((response) => {
                             this.levelOne = response.data; 
                             })
                        this.form.category = response.data.category;
                        getLevelTwo(response.data.category)
                        .then((response) => {
                            if(response.data.length > 0){
                                this.classifyInput = false
                                this.levelTwo = response.data; 
                            }else{
                                this.classifyInput = true
                            } 
                        })
                        this.form.classify = response.data.classify;
                        this.form.categoryStr = response.data.category;
                        this.form.classifyStr = response.data.classify;
                        this.form.reason = response.data.reason;
                        let dt = new Date();
                        this.startTimeStr = this.formatDateOne(dt);
                        this.form.startTime = this.formatDateOne(dt);
                        this.endTimeStr  = this.formatDateTwo(dt);
                        this.form.endTime = this.formatDateTwo(dt);
                    })
                
            },
            getLevelOneName(){
                getLevelId(this.levelOneId).then((response) => {
                    getLevelOne()
                            .then((response) => {
                             this.levelOne = response.data; 
                             })
                    this.form.category = response.data.seqId;
                    this.form.categoryStr = response.data.seqId;
                    getLevelTwo(response.data.seqId)
                        .then((response) => {
                            if(response.data.length > 0){
                                this.classifyInput = false
                                this.levelTwo = response.data; 
                            }else{
                                this.classifyInput = true
                            } 
                        })
                    if(this.levelTwoId != undefined){
                        this.form.classify = this.levelTwoId;
                        this.form.classifyStr = this.levelTwoId;
                    }
                })
            },
            formatDate(date) {
                let time = `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`
                return time;
            },
            formatDateOne(date) {
                date.setDate(date.getDate() + 1)
                let time = `${date.toLocaleDateString()}`
                return time;
            },
            formatDateTwo(date) {
                let time = `${date.toLocaleDateString()}`
                return time;
            },
            getUserApplyOne(){
                getLevelOne()
                    .then((response) => {
                        this.levelOne = response.data; 
                })
                account()
                     .then((response) => {
                        this.form.username = response.data.ladyName;
                })
                let dt = new Date();
                this.startTimeStr = this.formatDateOne(dt);
                this.form.startTime = this.formatDateOne(dt);
                this.endTimeStr  = this.formatDateTwo(dt);
                this.form.endTime = this.formatDateTwo(dt);
            },
            // back() {
            //     this.$router.go(-1);
            // },
            onClickLeft() {
                this.$router.go(-1);
            },
            a() {
                document.activeElement.blur();
            },
            close() {
                this.messageVisible = false;
            },
            startshow(type){
                this.show = true;
                this.timeType = type;
            },
            onConfirm(date) {
                this.show = false;
                if(this.timeType === 1){
                    this.startTimeStr = this.formatDate(date);
                    this.form.startTime = this.formatDate(date);
                }
                if(this.timeType === 2){
                    this.endTimeStr  = this.formatDate(date);
                    this.form.endTime = this.formatDate(date);
                }
            },
            onblur(index) {
                if (this.keyValue == '') {
                    let _that = this;
                    setTimeout(function(){
                        if (index == 1) {
                            _that.categoryShow = false;
                        } else if (index == 2) {
                            _that.classifyShow = false;
                        } else if (index == 3) {
                            _that.familyShow = false;
                        } else if (index == 4) {
                            _that.occupationShow = false;
                        }
                    }, 100);
                }

            },
            onfocus(index) {
                if (this.keyValue == '') {
                    if (index == 1) {
                        this.categoryShow = true;
                    } else if (index == 2) {
                        this.classifyShow = true;
                    } else if (index == 3) {
                        this.familyShow = true;
                    } else if (index == 4) {
                        this.occupationShow = true;
                    }

                }
            },
            btnChoose(item) {
                this.defaultMemberId = item.memberId;
                this.username = item.realname;
                this.mobile = item.category;
                this.address = item.address;
                this.memberNo = item.memberNo;
            },
            onSubmit() {
                //方式一
                if (this.form.category == '') {
                    this.$toast('请输入休假类别（I）');
                    // this.$toast({
                    //     message: '请输入休假类别（I）',
                    //     className: 'noticeWidth'   //所加样式名
                    // });

                    return;
                }
                // let reg = /^1[3456789]\d{9}$/;
                // if (!reg.test(this.form.tel)) {
                //     this.$toast("请输入正确的电话号码");
                //     return;
                // }
                if (this.form.reason === '') {
                    this.$toast('请输入休假原因');
                    return
                }
                this.addCustomer();
            },
            onOrderClassify(data1) {
                // console.log(data1)
                // data1 当前这一条的obj数据
                // index 当前选择的索引
                // data2 当前这一条数据的value
                // this.orderName = data1.configName
                this.levelTwo = [];
                this.form.category = data1.seqId;
                getLevelTwo(data1.seqId)
                    .then((response) => {
                        if(response.data.length > 0){
                            this.classifyInput = false
                            this.levelTwo = response.data; 
                        }else{
                            this.classifyInput = true
                        }
                    })
            },
            onOrderChildClassify(data1) {
                // console.log(data1)
                // data1 当前这一条的obj数据
                // index 当前选择的索引
                // data2 当前这一条数据的value
                // this.orderName = data1.configName
                var parentid = this.form.categoryStr;
                if (parentid === null || parentid === '' || parentid === 'undefined') {
                    this.$toast('请选择一级菜单');
                    return;
                }
                this.form.classify = data1.seqId;
            },
            addCustomer() {
                Dialog.confirm({
                    title: '提示',
                    theme: 'round-button',
                    confirmButtonColor: '#1989fa',
                    // cancelButtonColor: '#C8C9CC',
                    cancelButtonColor: '#969799',
                    message: '你确定要提交吗？',
                })
                .then(() => {
                add(this.form.category,this.form.classify,this.form.reason,this.form.startTime,this.form.endTime)
                    .then((response) => {
                        if (response.code === this.$API_CODE.OK) {
                            this.$toast.success({
                                message:'添加成功',
                                duration: 1000,
                                onClose:()=>{
                                    this.isSuccess = true;
                                //此处写提示关闭后需要执行的函数
                                this.$router.push({path: '/order'})
                                this.$router.go(0);
                                }
                            });
                        } else {
                            // this.messageVisible = true;
                            // this.message = response.message;
                            // this.btnDisable = false;
                            Dialog.alert({
                                message: response.message,
                                theme: 'round-button',
                                confirmButtonColor:"#1989fa"
                            }).then(() => {
                            // on close
                            });
                        }
                    })
                })
            }
        }
    }
</script>

<style lang="scss" scoped>


  .custom {
      padding: 14px;

      .header {
          color: #000000;
          font-weight: bold;
          text-align: left;
      }

      .title {
          text-align: left;
          margin: 10px 0;
      }

        /deep/ .van-field--disabled .van-field__label {
            color: #646566 !important;
        }
        // /deep/ .van-picker__column--selected {
        //     color: blue !important; /* 设置选中项的颜色为蓝色 */
        // }
        /deep/ .van-field__control:disabled {
            color: #646566;
            cursor: not-allowed;
            opacity: 1;
            -webkit-text-fill-color: #646566;
        }
        // /deep/ .van-field {
        //     font-weight: bold;
        // }

      /*焦点时内容为空*/
        .van-ellipsis:focus:before{
            content:none;
        }
        .memberGrade .van-ellipsis:empty:before{
            content: '请选择（必填）';   /* element attribute*/
            color: #C8C9CC;
        }

      .custom-content {
          margin: auto;
          width: 100%;
          font-size: 0.9rem;
          padding: 10px;
          border-radius: 5px;
          border: 1px solid #000000;
          background: #FFFFFF;
          p {
              margin-block-start: 0em;
              margin-block-end: 0em;
              float: left;
              width: auto;
              text-align: left;
          }

          input {
              float: right;
              width: 70%;
              border: 0;
              outline: none;
              font-size: 0.9rem;

          }
          label {
              float: left;
              text-align: left;
          }

      }
    }

</style>